import React from "react";

const DefaultText = ({ value }) => {
    return <span>{value}</span>;
};

export default DefaultText;
